import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../zustand/userStore";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import Popup from "../../features/EventOrganiser/Popup";
import { handlePopup, handleShowPopup } from "./redux/userSlice";
import { fetchOrgUsersById, fetchUserCrudAccess } from "./redux/userThunk";
import CrudAccess from "./CrudAccess";
import UserSelector from "./UserSelector";
import { setAppdAiUser } from "../../utils/appdAiHelpers";

const UserList = () => {
  const userData = userStore((state) => state.user);
  const { users, loading, error, showForm, showPopup } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();

  const userId = userStore((state) => state.user.id);

  // const userNumberLimit = userData.payments?.at(0).no_of_users || 0;
  const userNumberLimit = userData?.payments?.[0]?.no_of_users ?? 0;

  // const planType = userData.payments?.at(0).plan_type || "";
  const planType = userData?.payments?.[0]?.plan_type ?? "";

  useEffect(() => {
    if (userId) {
      dispatch(fetchOrgUsersById(userId));
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (userData) setAppdAiUser(userData, "demo");
  }, []);


  const dataTableColumns = [
    {
      Header: "#",
      accessor: "sno",
    },
    {
      Header: "User Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "role_name",
    },
    {
      Header: "Actions",
      accessor: "actions",
    },
  ];

  const handleUserCrudClick = (userId) => {
    dispatch(handleShowPopup({ show: true, userId }));
    dispatch(fetchUserCrudAccess(userId));
  };

  const processData = (usersArray) => {
    return usersArray.map((user, index) => ({
      ...user,
      sno: index + 1,
      actions: (
        <i
          className="fa fa-lock"
          style={{ cursor: "pointer", color: "#007BFF" }}
          // onClick={() => alert(`Lock clicked for user: ${user.name}`)}
          // onClick={() => dispatch(handleShowPopup(true))}
          //  onClick={() => dispatch(handleShowPopup({ show: true, userId: user.id }))}
          onClick={() => handleUserCrudClick(user.id)}
        ></i>
      ),
    }));
  };

  const handleAddUser = (e) => {
    e.preventDefault();

    if (planType === "customized" && processedUsers.length >= userNumberLimit) {
      return alert(
        `You have reached the maximum number of users allowed in your plan.`
      );
    }

    dispatch(handlePopup(true));
  };

  const processedUsers = processData(users || []);

  if (planType === "customized" && userNumberLimit === 1)
    return (
      <h5>
        Your current subscription plan does not allow access to the user module.
      </h5>
    );

  return (
    <div className="container-fluid px-5 px-2">
      <div className="md-px-2">
        <button
          className="btn btn-primary "
          style={{
            borderStyle: "none",
            borderRadius: "5px",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={handleAddUser}
        // onClick={() => dispatch(handlePopup(true))}
        >
          Add User
        </button>

        {loading && <p>Loading...</p>}
        {error && <p className="text-danger">Error: {error}</p>}

        {processedUsers.length > 0 ? (
          <AllFeatureDataTable
            columns={dataTableColumns}
            data={processedUsers}
          />
        ) : (
          !loading && <p>No Users Found</p>
        )}
        {showForm && (
          <Popup
            title={"Create New User "}
            minHeight="430px"
            maxWidth="800px"
            onClose={() => dispatch(handlePopup(false))}
          >
            {/* <CreateUser /> */}
            <UserSelector />
          </Popup>
        )}
        {showPopup && (
          <Popup
            title={"CRUD Access "}
            minHeight="250px"
            maxWidth="1000px"
            onClose={() => dispatch(handleShowPopup(false))}
          >
            <CrudAccess />
          </Popup>
        )}
      </div>
    </div>
  );
};

export default UserList;
